import { Divider, Stack, Typography } from '@mui/material';

import { ADDRESS, EMAIL, PHONE } from '@app/configs';
import { Logo } from '@app/components';

const Header = () => {
  const sx = { fontFamily: 'Verdana', lineHeight: 1.2, fontSize: 15 };

  return (
    <>
      <Stack p={2} pt={0} direction="row" justifyContent="space-between" alignItems="center">
        <Logo variant="dark" disabledLink sx={{ height: 120, width: 225 }} />

        <Stack width={250} spacing={0.5}>
          <Typography sx={sx}>{ADDRESS}</Typography>
          <Typography sx={sx}>
            <strong>Mob: </strong> {PHONE}
          </Typography>
          <Typography sx={sx}>
            <strong>Email:</strong> {EMAIL}
          </Typography>
        </Stack>
      </Stack>

      <Divider
        sx={{
          borderColor: '#3AC1EF',
          borderWidth: '2px',
          boxShadow: '2px 4px 4px 0 rgba(0, 0, 0, 0.5)',
        }}
      />
    </>
  );
};

export default Header;
